import { render } from "./CreateNetworkPermission.vue?vue&type=template&id=3480e624&scoped=true"
import script from "./CreateNetworkPermission.vue?vue&type=script&lang=js"
export * from "./CreateNetworkPermission.vue?vue&type=script&lang=js"

import "./CreateNetworkPermission.vue?vue&type=style&index=0&id=3480e624&lang=less&scoped=true"

import exportComponent from "/build/cloudstack-ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3480e624"]])

export default __exports__